// Temporary UI maintenance gate. Backend authorization remains unchanged.
export const canAccessDuringMaintenance = (email?: string | null) =>
   email?.trim().toLowerCase() === 'operator@forward-flow.com'

export const isMaintenancePublicPath = (pathname: string) =>
   ['/', '/signin', '/logout', '/forgot-password', '/set-new-password', '/terms', '/privacy'].includes(pathname)
